import React from 'react';

//Composants
import Title from '../../components/Title/Title';
import ContentText from '../../components/content/content-text.jsx';
import SimpleTitle from '../../components/Title/SimpleTitle';
import ContentSlider from '../../components/content/content-slider';
import Content from '../../components/content/content';
import Skills from '../../components/Projects/Skills.jsx';

//Contenus
import comm from '../../assets/content/projets/comm.json';


const Communication = () => {

    return (
        <div className='projet'>
            <div class="bloc">
                <Title title={comm.title} variant={comm.variant} />
                <ContentText content={comm.description} />


                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    <Content content={comm.partie1} image={{thumb: comm.img1,hd: comm.img1grd}} alt={comm.alt1} cote={"left"}></Content>
                    <Content content={comm.partie2} image={{thumb: comm.img2,hd: comm.img2grd}} alt={comm.alt2} cote={"right"}></Content>

                    <div className='content-text'>
                        <ContentText content={comm.partie3} />
                    </div>

                    <ContentSlider content={comm.partie4} images={comm.slider1} cote={"right"}></ContentSlider>
                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {comm.technologies.map((tech, index) => (
                    <Skills
                        image={tech.image}
                        alt={tech.alt}
                        competence={tech.name}
                        centered={tech.bool}
                    />
                ))}
                </div>
            </div>
            
        </div>
    );
};

export default Communication;